<p-dataView [value]="value" [paginator]="paginator" [rows]="rows" [totalRecords]="totalRecords" [paginatorPosition]="paginatorPosition"
    [showJumpToPageDropdown]="showJumpToPageDropdown" [showPageLinks]="showPageLinks" [lazy]="lazy" (onPage)="pageEvent($event)">
  <ng-template pTemplate="header" *ngIf="showHeader" let-rowData let-rowIndex="rowIndex" let-columns>
    <div *ngIf="showDataViewLayoutOptions" class="flex flex-column md:flex-row md:justify-content-between">
      <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
    </div>
    <ng-container *ngTemplateOutlet="headerTemplate; context: {$implicit: rowData, rowIndex: rowIndex, columns: columns}">
    </ng-container>
  </ng-template>
  <ng-template let-result pTemplate="listItem" let-rowData let-rowIndex="rowIndex" let-columns>
    <ng-container *ngTemplateOutlet="listItemTemplate; context: {$implicit: rowData, rowIndex: rowIndex, columns: columns}">
    </ng-container>
  </ng-template>
  <ng-template let-result pTemplate="gridItem" let-rowData let-rowIndex="rowIndex" let-columns>
    <ng-container *ngTemplateOutlet="gridItemTemplate; context: {$implicit: rowData, rowIndex: rowIndex, columns: columns}">
    </ng-container>
  </ng-template>
  <ng-template pTemplate="footer" *ngIf="showFooter" let-rowData let-rowIndex="rowIndex" let-columns>
    <ng-container *ngTemplateOutlet="footerTemplate; context: {$implicit: rowData, rowIndex: rowIndex, columns: columns}"></ng-container>
  </ng-template>
</p-dataView>
